export const makeLoaderWrapper = () => {
  return `height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;`
}
